<template>
    <path d="M6.119 11.414l.788-.789a.482.482 0 00-.007-.688L3.657 6.822H17.51a.482.482 0 00.482-.482V5.215a.482.482 0 00-.482-.482H3.657L6.9 1.618A.482.482 0 006.907.93L6.118.14a.482.482 0 00-.681 0L.14 5.437a.482.482 0 000 .682l5.296 5.295a.482.482 0 00.682 0z" fill-rule="evenodd"></path>
</template>

<script>
export default {
    name: 'backIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 12');
    }
}
</script>
